<!-- eslint-disable vue/no-v-html -->

<template>
  <div class="modal-option-checkbox__checkbox-wrapper">
    <div
      class="modal-option-checkbox modal-option-checkbox--background-blue site-checkbox"
      :class="disabled && 'modal-option-checkbox--disabled'"
    >
      <input
        id="modal-option-checkbox"
        v-model="optionChecked"
        type="checkbox"
        class="modal-option-checkbox__input"
        value="1"
      />

      <label
        for="modal-option-checkbox"
        class="site-checkbox__label site-checkbox__label--flex"
      >
        <span v-once>
          <span class="modal-option-checkbox__title">{{
            modalOptionTitle
          }}</span>

          <span
            class="modal-option-checkbox__description"
            v-html="modalOptionDescription"
          ></span>
        </span>

        <span v-once class="modal-option-checkbox__optional">
          <span class="modal-option-checkbox__optional-title">{{
            optionalTitle
          }}</span>
          <span class="modal-option-checkbox__optional-price">{{
            valueLabel
          }}</span>
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalOptionCheckbox',
  model: {
    prop: 'checked',
  },
  props: {
    modalOptionTitle: {
      type: String,
      required: true,
    },
    modalOptionDescription: {
      type: String,
      required: true,
    },
    optionalTitle: {
      type: String,
      required: true,
    },
    valueLabel: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      option: null,
    };
  },
  computed: {
    optionChecked: {
      get: function () {
        return !this.disabled && this.checked;
      },
      set: function (checked) {
        this.$emit('input', checked);
      },
    },
  },
};
</script>
